import type { PopperProps } from '@zoryn/components/popper'
import type { ComputedRef, InjectionKey, Ref } from 'vue'

export type ZDropdownInjectionContext = {
  contentRef: Ref<HTMLElement | undefined>
  role: ComputedRef<PopperProps['role']>
  triggerId: ComputedRef<string>
  isUsingKeyboard: Ref<boolean>
  onItemLeave: (e: PointerEvent) => void
  onItemEnter: (e: PointerEvent) => void
  handleClose: () => void
}

export const DROPDOWN_INJECTION_KEY: InjectionKey<ZDropdownInjectionContext> =
  Symbol('drDropdown')

export const DROPDOWN_INSTANCE_INJECTION_KEY = 'elDropdown'
